import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'subaward-details',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Subaward Details',
    display: {
      isMain: false,
      position: 6,
    },
    name: 'Subaward Details',
    page: { alias: 'sr:subaward-details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
